import store from '@/store'
import { Entity } from '@/store/entity'

export class Branch extends Entity {
  get partner() {
    const partner = store.getters['partner/getPartner']

    if (!partner) {
      store.dispatch('partner/fetchPartner')
    }

    return partner
  }
}
